import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft as back } from '@fortawesome/free-solid-svg-icons';
import ExhibitorActivities from '../exhibitor/ExhibitorActivities';
import { activityDate2Human } from '../../utils/dateTime';
import FavoritesIndicator from '../favorites/FavoritesIndicator';

const ActivityMain = ({ activity }) => {
	const { t, i18n } = useTranslation();
	const lang = i18n.language;
	const navigate = useNavigate();

	return (
		<div className='Exhibitor-main'>
			<h1>{activity.name[lang]}</h1>

			<p><b>{t('activity.host')}</b><br/>
			<span className='a' onClick={() => navigate(`../exhibitor/${activity.exhibitor._id}`)}>{activity.exhibitor.name[lang]}</span></p>

			{activity.speaker[lang] && <p>
			<b>{t('activity.speaker')}</b><br/>
			{activity.speaker[lang]}</p>}

			<p><b>{t('activity.date')}</b><br/>
			{activityDate2Human(activity.date, lang)}</p>

			{activity.descr[lang] && <p>
			<b>{t('activity.descr')}</b><br/>
			{activity.descr[lang]}</p>}

			<div className='p'>
				<FavoritesIndicator type='activity' object={activity}/>
			</div>

			<ExhibitorActivities exhibitor={activity.exhibitor} title='activity.other'/>

			<div className='button' onClick={() => navigate(`../activities/${activity.event._id}`)}>
				<div className='button-icon'>
					<FontAwesomeIcon icon={back} size='lg'/>
				</div>
				<div className='button-text'>
					{t('activity.back')}
				</div>
			</div>
		</div>
	);
};

ActivityMain.propTypes = {
    activity: PropTypes.object.isRequired,
};

export default ActivityMain;
